import { DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-registration-closed',
  imports: [
    DatePipe
  ],
  templateUrl: './registration-closed.component.html',
  styleUrl: './registration-closed.component.scss'
})
export class RegistrationClosedComponent {
  private readonly route = inject(ActivatedRoute);
  event = this.route.parent!.snapshot.data['event'];  // added by resolver

  contactEmail: string = environment.contact_email;

  constructor() {
  }

}
